module.exports = __webpack_public_path__ + "static/media/cheers.ec8acdd0.png";